import { render } from "./login-account.vue?vue&type=template&id=3c1c11b0&ts=true"
import script from "./login-account.vue?vue&type=script&lang=ts"
export * from "./login-account.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__